import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'nonDecimal'})
export class NonDecimalPipe implements PipeTransform {

    transform(pAmount: number): string {
        if (pAmount) {
            return pAmount.toLocaleString('en-IN', {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
            });
        } else if (pAmount == 0) {
            return '0';
        } else if (pAmount == null) {
            return '0';
        }
    }
}